import { request, makePath } from './http';
const API_NAME = 'servicerequest';

export function createRequest(data) {
  return request('POST', makePath(API_NAME), {body: data});
}

export function listRequests() {
  return request('GET', makePath(API_NAME));
}

// Superadmin call that gets all requests
export function adminListRequests(request_type=null, status=null, limit=100, offset=0) {
  return request('GET', makePath(API_NAME, 'admin'), {params: {request_type, status, limit, offset}});
}
